import React, { useEffect, useRef } from "react";
import { PageHeader } from "@features/shared";
import { usePageInitialization } from "@features/shared/hooks/usePageInitialization";
import { useLocation } from "react-router-dom";
import { MyDealerForm } from "./components";
import { MySR } from "@shared/components";

/**
 * Barrel export for My Dealer feature
 */

export { MyDealerForm } from "./components";
export * from "./hooks";
export * from "./services";

/**
 * MyDealerPage - Page wrapper
 * Dealer market working page with auto-scroll behavior
 * Scrolls to bottom when navigated from another page (location.state.from === true)
 */
export const MyDealerPage = () => {
  usePageInitialization();

  const location = useLocation();
  const messagesEndRef = useRef(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    if (location?.state?.from === true) {
      scrollToBottom();
    }
  }, [location?.state]);

  return (
    <>
      <PageHeader title="Market Working" path="/" />
      <div className="container p-0">
        <MyDealerForm />
        <MySR />
        <div ref={messagesEndRef} />
      </div>
    </>
  );
};
